import { render, staticRenderFns } from "./ExscientiaBanner.vue?vue&type=template&id=e84e374c&"
import script from "./ExscientiaBanner.vue?vue&type=script&lang=ts&"
export * from "./ExscientiaBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ExscientiaBanner.vue?vue&type=style&index=0&id=e84e374c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../Auth/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports